import Vue from 'vue'

// 确保这是全局唯一的事件总线实例
const EventBus = new Vue()

// 导出这个实例（重要！不要直接导出new Vue()）
export default EventBus